import ReCaptcha from '../google-captcha';

require('./subscribe-form.less');
import Trackers from '../tracker/tracker';
import PreLoader from '../../modules/preloader';

let captcha, bxCaptchaSid;

let recaptchaPrompt = {
    recaptchaForm: {
        html: $('.js-recaptcha-component')
            .remove()
            .html(),
        submit: function(e) {
            e.preventDefault();
            const trackers = new Trackers();
            var $this = $('form.subscribe-form__form.js-subscribe-form');
            var $errorBlock = $this.find('.subscribe-form__error');
            var $emailInput = $this.find('input[type=email]');

            window.grecaptcha = window.grecaptcha ? window.grecaptcha : {};
            let currentCaptchaId = window.Recaptchafree.items[window.Recaptchafree.items.length - 1];
            let recaptchaResponse = grecaptcha.getResponse(currentCaptchaId) || '';
            let email = $this.find('.subscribe-form__input').val();
            if (!recaptchaResponse) {
                $('.captcha-field-subscribe .form__captcha-error')
                    .html('Необходимо выполнить captcha!' + '<br>')
                    .addClass('form__error-msg');
                return;
            } else {
                const loader = new PreLoader();
                loader.show();
                $.ajax({
                    type: 'POST',
                    url: '/ajax/action/subscribe_form/subscribe/',
                    data: {
                        email: email
                    },
                    success: function(response) {
                        loader.hide();
                        if (response.message == 'ok') {
                            $errorBlock.remove();
                            $emailInput.removeClass('subscribe-form__input--error');

                            var $successBlock = $this.closest('.subscribe-form').find('.subscribe-form__success');

                            $successBlock.fadeIn(300);
                            trackers.onSubscriptionDone();

                            $('.form__captcha-success').html('Вы успешно подписаны!' + '<br>');
                            $('.b-form-subscribe').remove();
                        } else {
                            $errorBlock.text(response.message);
                            $emailInput.addClass('subscribe-form__input--error');
                            $this.find('.subscribe-form__input-field').prepend($errorBlock);

                            $('.captcha-field-subscribe .form__captcha-error')
                                .html(response.message + '<br>')
                                .addClass('form__error-msg');
                        }
                    },
                    dataType: 'json'
                });
            }
            e.preventDefault();
        }
    }
};

module.exports = recaptchaPrompt;

jQuery(function ($) {
    var $subscribeForm = $('.js-subscribe-form');

    const trackers = new Trackers();

    $subscribeForm.attr('novalidate', true);

    $subscribeForm.submit(function (e) {
        e.preventDefault();
        trackers.onSubscribe();
        var $this = $(this);
        var $errorBlock = $this.find('.subscribe-form__error');
        if ($errorBlock.length == 0) $errorBlock = $('<div class="subscribe-form__error" />');
        var $emailInput = $this.find('input[type=email]');
        var emailPattern = /^([a-z0-9_.-])+@[a-z0-9-]+\.([a-z]{2,4}\.)?[a-z]{2,4}$/i;
        window.grecaptcha = window.grecaptcha ? window.grecaptcha : {};
        $('.subscribe-form__content .form__captcha-error').removeClass('form__error-msg');
        $('.subscribe-form__content .form__captcha-error').html(' ');
        if (emailPattern.test($emailInput.val())) {
            $errorBlock.text('');
            $.prompt(recaptchaPrompt, {
                initialState: 'recaptchaForm',
                statechanging: function (e, from, to) {
                    window.Recaptchafree.render();
                }
            });
        } else {
            $errorBlock.text('Указан неверный e-mail');
            $emailInput.addClass('subscribe-form__input--error');
            $this.find('.subscribe-form__input-field').prepend($errorBlock);
        }
    });
});



// WEBPACK FOOTER //
// ./blocks/subscribe-form/subscribe-form.js